export default __webpack_public_path__ + "static/medical-prof-e48283e72f3b291be56f9b3279cd12b6.jpg";